module.exports = "/_next/static/images/NoInternet-0b653646d9f1a8c47f42bb0710c8ae9f.png";